import { Box, BoxProps, ColorOptions, Spacer } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { FC, useEffect, useState } from 'react'
import { Dropdown } from '../../components/Dropdown'
import { ModalAlertView } from '../../components/ModalAlertView'
import { useLazyApiData, useStores } from '../../data/store'
import { statusData } from '../../utils/constants'

interface CardFormProps {
  cardMapping: any
  onUpdate: () => void
  isDeletable: boolean
  onClose: () => void
}
const CardForm: FC<CardFormProps> = (props: CardFormProps) => {
  const { onUpdate, cardMapping, isDeletable, onClose } = props
  const { id, entityID, status } = cardMapping
  const [value, setValue] = useState(status)
  console.log({ id })
  const { updateCard, deleteCard } = useStores((store) => ({
    updateCard: store.card.updateCard,
    deleteCard: store.card.deleteCard,
  }))

  const [lazyUpdate, lazyUpdateHandler] = useLazyApiData(updateCard)
  const [lazyDelete, lazyDeleteHandler] = useLazyApiData(deleteCard)

  const [toggle, setToggle] = useState(false)
  const onDelete = () => {
    lazyDelete(entityID, id)
  }

  const onDismiss = () => {
    setToggle(false)
  }

  const deleteMapping = () => {
    console.log('delete')
    setToggle(true)
  }

  const updateMapping = (values: any) => {
    console.log('update')
    lazyUpdate({ id, entityID, status: values.status === 'Enable' ? true : false })
  }

  useEffect(() => {
    if (lazyUpdateHandler.state === 'fulfilled') {
      onUpdate()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyUpdateHandler])

  useEffect(() => {
    if (lazyDeleteHandler.state === 'fulfilled') {
      onUpdate()
      setToggle(false)
    }
    if (lazyDeleteHandler.state === 'rejected') {
      setToggle(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyDeleteHandler])

  return (
    <Box {...styles.formContainer} flexDirection="row" align={'flex-end'} flexWrap={'wrap'}>
      <Box w={200} pv={8}>
        <Dropdown
          data={statusData}
          title={status === 'Enabled' ? 'Enable' : 'Disable'}
          label={'Status'}
          selectedData={setValue}
        />
      </Box>
      <ModalAlertView
        onPress={onDelete}
        show={toggle}
        onDismiss={onDismiss}
        onCancel={onDismiss}
        title="Delete Card Mapping"
        buttonTitle="Delete"
        message={`Is this final. This will delete mapping with ID ${id} and Entity Id ${entityID}.`}
        isLoading={lazyDeleteHandler.state === 'pending'}
      />
      <Spacer direction={'horizontal'} size={16} />
      <ButtonNew
        title={'Update Mapping'}
        onPress={() => updateMapping({ status: value })}
        height={36}
        color={'YELLOW'}
        hoverColor={'YELLOW'}
        textType={'body14'}
        paddingVertical={8}
        isLoading={lazyUpdateHandler.state === 'pending'}
      />
      <Spacer direction="horizontal" size={16} />
      {isDeletable && entityID && (
        <ButtonNew
          title={'Delete Mapping'}
          onPress={deleteMapping}
          height={36}
          color={'RED'}
          hoverColor={'RED'}
          textType={'body14'}
          paddingVertical={8}
          isLoading={lazyDeleteHandler.state === 'pending'}
        />
      )}
    </Box>
  )
}

export { CardForm }

const styles = {
  formContainer: {
    underlayColor: 'WHITE',
    bg: '#0000001f' as ColorOptions,
    maxheight: 200,
    pv: 16,
    ph: 20,
  } as BoxProps,
}
